import { Outlet } from "react-router-dom"

export default function OutletPage() {
	return (
		<>
			<div className="w-full">
				<Outlet />
			</div>
		</>
	)
}
